import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {SitePublicService} from 'src/app/services/site-public.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {FileManagerComponent} from 'src/app/shared/file-manager/file-manager.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-depto-dialog',
  templateUrl: './depto-dialog.component.html',
  styleUrls: [ './depto-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class DeptoDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;

  public image_path: string;

  @ViewChild(FileManagerComponent) fileManager!: FileManagerComponent;

  constructor (
    public matDialogRef: MatDialogRef<DeptoDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    private _sitePublicService: SitePublicService,
    private _spinnerService: SpinnerService,
    public _snackBar: SnackBarIconService,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.entityForm = this.createForm(this.data)
    this.isEdit = this.data.id !== '0';
    if (this.isEdit) {
      this.image_path = "site_pub/deptos/" + this.data.id
      // console.log("image_path: " + this.image_path)
    }


  }

  async ngOnInit () {
    this._adapter.setLocale('pt');
  }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      short: new FormControl(data.short, [ Validators.required ]),
      name: new FormControl(data.name, [ Validators.required ]),
      prompt: new FormControl(data.prompt),
      html: new FormControl(data.html),
      context: new FormControl(data.context),
      preview: new FormControl(data.preview),
      message: new FormControl(data.message),
      canPublish: new FormControl(data.canPublish),
    });

    return form
  }

  previewContent () {
    const preview = this.entityForm.controls.preview.value;
    this._sitePublicService.displayHtml(preview)
  }

  publishContent () {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "Deseja publicar esta página?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        const html = this.entityForm.controls.preview.value;
        this.entityForm.controls.html.setValue(html)

        this._snackBar.openSnackBar("Sucesso!", '', 'success')

      }
    })
  }

  async generateGeminiContent () {
    const waiting = this._spinnerService.show();
    try {
      const context = this.entityForm.controls.context.value;
      const pronpt = this.entityForm.controls.prompt.value;
      const files = this.fileManager.getFiles();
      const finalPrompt = context + '\n' + pronpt + '\n' + files;
      /*
      console.log("+++++++++++++++++++++++++++++++++++")
      console.log("files: " + files);
      console.log("+++++++++++++++++++++++++++++++++++")
      */

      // const html: string = await this._sitePublicService.generateHtmlPage(finalPrompt);
      const html: string = await this._sitePublicService.generateGeminiContent(finalPrompt);
      const style: string = await this._sitePublicService.extractStyle(html);
      const body: string = await this._sitePublicService.extractBody(html);

      // console.log("html: " + html)

      // console.log("style: " + style)
      // console.log("---------------------------------------")
      // console.log("body: " + body)

      this.entityForm.controls.preview.setValue(style + '\n' + body);


    } catch (error) {
      // Captura qualquer erro relançado pelo serviço
      console.error("Falha ao atualizar o formulário com HTML.", error);
      // Opcional: mostrar uma mensagem de erro para o usuário aqui
    } finally {
      waiting.close();
    }
  }

  update () {
    const formData = this.entityForm.getRawValue();
    // console.log(JSON.stringify(formData));
    this._sitePublicService.updateDepto(formData)
      .then(() => {
      })
      .catch((err: any) => {
        console.log("erro: " + err.message)
      })
  }

}

